import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from "../views/Login.vue"
import Dashboard from "../views/Dashboard.vue"
import Signup from "../views/Signup.vue"
import CreateCar from "../views/CreateCar.vue"
import CarDetails from "../views/CarDetails.vue"
import EditCar from "../views/EditCar"
import GasStations from "../views/GasStations.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: "Login",
    component: Login
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/signup",
    name: "Sign Up",
    component: Signup
  },
  {
    path: "/createCar",
    name: "Create Car",
    component: CreateCar
  },
  {
    path: "/cars/:carId",
    name: "specificCar",
    components: { default: CarDetails },
    props: { default: true }
  },
  {
    path: "/cars/:carId/edit",
    name: "Edit Car",
    components: { default: EditCar},
    props: { default: true}
  },
  {
    path: "/cars/:carId/gasStations",
    name: "Gas Stations",
    components: {default: GasStations},
    props: { default: true}
  }
]

const router = new VueRouter({
  routes
});

export default router
